export default __webpack_public_path__ + "static/media/random_router.fa2dab45.png";